import { reduxKey } from './constants';
export function getEarningsCalculatorState(state) {
    if (!state[reduxKey]) {
        return {};
    }
    return state[reduxKey];
}
//# sourceMappingURL=selectors.js.map